import type { SystemStyleObject } from "@chakra-ui/theme-tools"

const baseStyle: SystemStyleObject = {
  w: "100%",
  mx: "auto",
  maxW: "60ch",
  px: "1rem",
}

export default {
  baseStyle,
}
